import { IGetMasterIndirectTasksOutput } from '@services/coralservices/serviceClients/IhmLaborTrackingServiceClient';

export const TIME_OFF_TASK = 'Idle time task';

export class MasterIndirectTaskService {
    private static _instance: MasterIndirectTaskService;
    private config: IGetMasterIndirectTasksOutput;
    private selectedTask: string;
    private selectedDirectTask: string;
    private isIndirectTask: boolean;
    private pureMIEvent: boolean;

    public constructor() {
        this.selectedTask = TIME_OFF_TASK;
        this.selectedDirectTask = '';
        this.isIndirectTask = false;
        this.pureMIEvent = true;
    }

    public static getInstance = (): MasterIndirectTaskService => {
        if (!MasterIndirectTaskService._instance) {
            MasterIndirectTaskService._instance = new MasterIndirectTaskService();
        }

        return MasterIndirectTaskService._instance;
    };

    public setConfig = (configuration: IGetMasterIndirectTasksOutput) => {
        this.config = configuration;
    };

    public getConfig = (): IGetMasterIndirectTasksOutput => {
        return this.config;
    };

    public setMITask = (task: string) => {
        this.selectedTask = task;
    };

    public getMITask = () => {
        return this.selectedTask;
    };

    public setDirectTask = (task: string) => {
        this.selectedDirectTask = task;
    };

    public getDirectTask = () => {
        return this.selectedDirectTask;
    };

    public setIndirect = (isIndirectTaskSelected: boolean) => {
        this.isIndirectTask = isIndirectTaskSelected;
    };

    public getIndirectStatus = () => {
        return this.isIndirectTask;
    };

    public setPureEvent = (isPureEvent: boolean) => {
        this.pureMIEvent = isPureEvent;
    };

    public getPureEvent = () => {
        return this.pureMIEvent;
    };

    public setToT = () => {
        this.selectedTask = TIME_OFF_TASK;
        this.pureMIEvent = true;
    };
}
